<template>
    <div class="container-fluid" id="dvcrud">
        <div class="row">
            <div class="col-md-12">
                <breadcrumb v-bind:bcitens="itensbc" v-bind:mtdcancelar="mtdcancelaredicao"></breadcrumb>
            </div>
            <div class="col-md-12">
                <div id="pnlista" class="card" style="display: none;">
                    <div class="card-header"><span id="titlista">LISTAGEM DE {{ itensbc.item1.titulo }}</span>
                        <router-link to="/">
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                        </router-link>
                    </div>
                    <div class="card-body" style="padding: 10px;">
                        <div class="row">
                            <div class="col-sm-4 col-md-2 col-lg-2">
                                <label for="cbopfiltro">Filtrar:</label>
                                <select name="cbopfiltro" class="form-control form-control-sm" id="cbopfiltro" v-model="pfiltro" @change="mtdlimpar_listagem()">
                                    <option value="0">Código</option>
                                    <option value="1">Descrição</option>
                                </select>
                            </div>
                            <div class="col-sm-8 col-md-6 col-lg-6">
                                <label for="edconteudopesq">Conteúdo da pesquisa:</label>
                                <input id="edconteudopesq" type="text" class="form-control form-control-sm" v-model="pconteudo" @keyup="mtdlimpar_listagem()">
                            </div>
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <label for="cbqtdreg">Registros:</label>
                                <select name="cbqtdreg" class="form-control form-control-sm" id="cbqtdreg" v-model="pqtdregistros" @change="mtdlimpar_listagem()">
                                    <option value="10">10</option>
                                    <option value="20">20</option>
                                    <option value="30">30</option>
                                    <option value="40">40</option>
                                    <option value="50">50</option>
                                    <option value="99999999999">Todos</option>
                                </select>
                            </div>
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <button type="button" id="btlistar" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdexecutapesquisa()"><i class="fa fa-search"></i> Listar</button>
                            </div>
                            <div class="col-md-12" style="margin-top: 10px;">
                                <vue-bootstrap4-table
                                        :rows="lstplanospagamento"
                                        :columns="columns"
                                        :config="config"
                                        :classes="classes">
                                    <template slot="empty-results">
                                        <div class="col-md-12 text-center">Sem dados para visualização</div>
                                    </template>
                                    <!-- ícones de ordenação da table -->
                                    <template slot="sort-asc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-asc"></i>
                                    </template>
                                    <template slot="sort-desc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-desc"></i>
                                    </template>
                                    <template slot="no-sort-icon">
                                        <i class="fa-icones-ordenacao fa fa-unsorted"></i>
                                    </template>                                    
                                    <!--  -->                                    
                                    <template slot="id_f" slot-scope="item">
                                        {{ item.row.id }}
                                    </template>
                                    <template slot="tipo_f" slot-scope="item">
                                        <span v-if="item.row.tipo === 0" class="badge badge badge-pill badge-primary">A vista</span>
                                        <span v-else class="badge badge badge-pill badge-danger">A prazo</span>
                                    </template>                                     
                                    <template slot="opcoes" slot-scope="item">
                                        <button type="button" class="btn btn-info btn-sm btn-opcrud ajt-btn" @click.prevent="mtdalterar(item.row)"><i class="fa fa-edit"></i></button>
                                        <button type="button" class="btn btn-danger btn-sm btn-opcrud ajt-btn" @click.prevent="mtdexcluir(item.row)"><i class="fa fa-trash"></i></button>
                                    </template>
                                </vue-bootstrap4-table>
                            </div>
                            <div class="col-md-12">
                                <ul class="list-group">
                                    <li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
                                        Registros
                                        <span class="badge badge-info badge-pill text-right bdg-qtd-reg-info">{{lstplanospagamento.length}}</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer" style="padding: 10px;">
                        <div class="row">
                            <div class="col-8 col-sm-8 col-md-10 col-lg-10" id="dvpaginacao">
                                <v-pagination
                                        v-model="pagina_atual"
                                        :page-count="pqtd_paginas"
                                        :classes="bootstrapPaginationClasses">
                                </v-pagination>
                            </div>
                            <div class="col-4 col-sm-4 col-md-2 col-lg-2">
                                <button type="button" class="btn btn-success btn-sm btn-block" @click.prevent="mtdnovo()"><i class="fa fa-file"></i> Novo</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div id="pncadastro" class="card" style="display:none;">
                    <div class="card-header"><span>{{itensbc.item2.titulo}}</span>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click.prevent="mtdcancelaredicao()"><span aria-hidden="true">&times;</span></button>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="edid">Código:</label>
                                <input type="text" class="form-control form-control-sm" id="edid" v-model="vid"
                                       maxlength="20" style="text-transform: uppercase;" disabled/>
                            </div>
                            <div class="col-sm-12 col-md-8 col-lg-8">
                                <label for="eddescricao">*Descrição:</label>
                                <input type="text" v-model="vdescricao" v-bind:disabled="ativadesativa"
                                       class="form-control form-control-sm" id="eddescricao" maxlength="50"
                                       style="text-transform: uppercase;">
                            </div>                          
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="cbtipo">Tipo:</label>
                                <select class="form-control form-control-sm" id="cbtipo" v-model="wt_tipoPlano"
                                        v-bind:disabled="ativadesativa">
                                    <option value="0">A vista</option>
                                    <option value="1">A prazo</option>
                                </select>
                            </div>                            
                        </div>
                        <div class="row">
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="cbtipo">Permite Descto:</label>
                                <select class="form-control form-control-sm" id="cbtipo" v-model="vpermitedesconto"
                                        v-bind:disabled="ativadesativa">
                                    <option value="0">Não</option>
                                    <option value="1">Sim</option>
                                </select>
                            </div>                            
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="edpercentrada">Entrada(%):</label>
                                <money type="text" class="form-control form-control-sm" id="edpercentrada" v-model="vpercentrada" v-bind="money" style="text-align:right;" v-bind:disabled="planoPrazo"></money>
                            </div>                            
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <label for="cbidforma">*Forma de pagamento:</label>
                                <select id="cbidforma" v-model="vidforma" v-bind:disabled="ativadesativa"
                                        data-placeholder="Selecione uma opção" data-allow-clear="true"
                                        style="width:100%;">
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <label for="cbidtabela">*Tabela de preço:</label>
                                <select id="cbidtabela" v-model="vidtabela" v-bind:disabled="ativadesativa"
                                        data-placeholder="Selecione uma opção" data-allow-clear="true"
                                        style="width:100%;">
                                </select>
                            </div>                             
                        </div>

                        <div class="row">
                            <div class="col-sm-12 col-md-6 col-lg-6">
                                <label for="cbidtipocobranca">Tipo de cobrança:</label>
                                <select id="cbidtipocobranca" data-placeholder="Selecione uma opção" data-allow-clear="true"
                                        style="width:100%;" v-model="vidtipocob" v-bind:disabled="planoPrazo">
                                </select>
                            </div>                          
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="edqtdparc">Qtd. Parcelas:</label>
                                <input type="number" v-model="vqtdparc" v-bind:disabled="planoPrazo"
                                    class="form-control form-control-sm" id="edqtdparc" min="1">
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="edprazos">Prazo:</label>
                                <input type="number" v-model="vprazos" v-bind:disabled="planoPrazo"
                                    class="form-control form-control-sm" id="edprazos" min="1">
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2" style="padding-top: 20px;">
                                <button v-if="planoPrazoLista" type="button" id="btinplano" @click.prevent="mtdlancarPrazos()" 
                                  class="btn btn-success btn-sm" style="width:100%" v-bind:disabled="ativadesativa"><i class="fa fa-plus-circle"></i> Incluir</button>
                            </div>

                            <div v-if="planoPrazoLista" class="col-sm-12 col-md-12 col-lg-12" style="padding-top: 15px;">
                              <div class="list-group">
                                  <a v-for="prazosplanos in lstprazosplanos" v-bind:key="prazosplanos.idparcela" 
                                    href="#" @click.prevent="" class="list-group-item list-group-item-action">
                                      <button v-if="parseInt(opcrud) < 3" type="button" class="close" aria-label="Excluir" @click.prevent="mtdexcluirprazo(prazosplanos)">
                                          <span aria-hidden="true"><i class="fa fa-trash excplanos"></i></span>
                                      </button>
                                      <button v-if="parseInt(opcrud) < 3" type="button" class="close" aria-label="Alterar" @click.prevent="mtdalterarprazos(prazosplanos)">
                                          <span aria-hidden="true"><i class="fa fa-edit excplanos"></i></span>
                                      </button>
                                                                              
                                      <span class="titplanos">{{ prazosplanos.idparcela }} - {{ prazosplanos.descricaocob }}</span>
                                      <span class="titplanos badge badge-pill badge-primary" style="margin-left: 60px; width: 60px;">{{ prazosplanos.prazo }}</span>
                                  </a>
                              </div>
                            </div>
                        </div>
                    </div>

                    <!-- ALTERAR PRAZOS -->
                    <div class="modal fade" id="mdprazos">
                      <div class="modal-dialog">
                        <div class="modal-content">                        
                          <div class="modal-header">
                            <h4 class="modal-title">ALTERAR PRAZO DA PARCELA {{ vidparcelaalt }}</h4>
                            <button type="button" class="close" data-dismiss="modal">&times;</button>
                          </div>
                          
                          <div class="modal-body">
                              <label for="edvprazoalt">Prazo:</label>
                              <input type="number" v-model="vprazoalt" v-on:keyup="checkKeyUpParcela"
                                  class="form-control form-control-sm" id="edvprazoalt" min="1" autofocus>
                          </div>
                                                    
                          <div class="modal-footer">
                            <button type="button" class="btn btn-primary" data-dismiss="modal">Cancelar</button>
                          </div>
                          
                        </div>
                      </div>
                    </div>
                    <!-- FIM ALTERAR PRAZOS -->

                    <div class="card-footer">
                        <div class="row">
                            <div class="col-sm-8">
                                <h5 style="font-size: 16px; color: #545b62; margin-top: 5px;"><strong>Campos com asterisco(*) devem ser informados</strong>.</h5>
                            </div>
                            <div class="col-sm-2">
                                <button id="btgravar" v-if="(opcrud == 1)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Gravar
                                </button>
                                <button id="btgravar" v-else-if="(opcrud == 2)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Alterar
                                </button>
                                <button id="btgravar" v-else-if="(opcrud == 3)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Excluir
                                </button>
                            </div>
                            <div class="col-sm-2">
                                <button type="button" @click.prevent="mtdcancelaredicao()" class="btn btn-secondary btn-sm" style="width:100%">
                                    <i class="fa fa-close"></i> Cancelar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import BreadCrumb from '../components/cmpbreadcrumb.vue'
    import VueBootstrap4Table from 'vue-bootstrap4-table'
    import vPagination from 'vue-plain-pagination'
    import util from '../utilitarios/util.js'

    export default {
        name: 'cadplanospagamento',
        components:{
            VueBootstrap4Table,
            vPagination,
            'breadcrumb' : BreadCrumb
        },
        data: function() {
            return {
                lstplanospagamento    : [],
                pfiltro               : 1,
                pconteudo             : '',
                pqtdregistros         : 10,
                pqtd_paginas          : 1,
                pagina_atual          : 1,
                pqtd_total_registros  : 0,

                //variáveis do crud
                opcrud                :  0,
                vid                   : '',
                vdescricao            : '',
                vidtabela             : null,
                vidforma              : null,
                vtipo                 : 0,
                vpermitedesconto      : 1,
                vpercentrada          : 0,

                wt_tipoPlano          :  0,
                vidtipocob            : null,
                lstprazosplanos       : [],
                vqtdparc              :  1,
                vprazos               : 30,

                planoPrazo            : true,
                planoPrazoLista       : false,
                vprazoalt             :  1,
                vidparcelaalt         : null,

                //variável para habilitação dos campos
                ativadesativa         : true,
				money				: {
                    decimal         : ',',
                    thousands       : '.',
                    prefix          : '',//aqui colocar o cifrão se for necessário
                    precision       : 2,
                    masked          : false
                },
                bootstrapPaginationClasses: {
                    ul: 'pagination pagination-sm',
                    li: 'page-item',
                    liActive: 'active',
                    liDisable: 'disabled',
                    button: 'page-link'
                },
                itensbc : {
                    item1 : {
                        titulo : 'PLANOS DE PAGAMENTO',
                        ativo  : false
                    },
                    item2 : {
                        titulo : '',
                        ativo  : false
                    }
                },
                columns: [
                    {
                        label: 'Opções',
                        name : 'opcoes',
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        row_classes: "def-col-opcoes",
                        sort: false
                    },
                    {
                        label: "Código",
                        name: "id",
                        sort: true,
                        slot_name: "id_f",
                        row_classes: "def-col-cod",
                    },                   
                    {
                        label: "Descrição",
                        name: "descricao",
                        initial_sort : true,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Tipo",
                        name: "tipo",
                        initial_sort : true,
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        slot_name: "tipo_f",
                        row_classes: "def-col-tipo"
                    }                    
                ],
                config: {
                    pagination: false,
                    pagination_info: false,
                    card_mode: false,
                    global_search: {
                        visibility: false,
                    },
                    show_refresh_button : false,
                    show_reset_button : false
                },
                classes: {
                    table: "table-bordered table-striped table-sm"
                }
            }
        },
        methods:{
          mtdfiltropesquisa(){
              let rfiltro = '';
              if (parseInt(this.pfiltro) === 0){
                  rfiltro = this.pconteudo === '' ? '' : ' and p.id='+this.pconteudo;
              }else{
                  rfiltro = this.pconteudo === '' ? '' : ' and upper(p.descricao) like upper(\''+this.pconteudo+'%\')';
              }
              return rfiltro;
          },
          mtdexecutapesquisa(){
              var vself           = this;
              let filtro          = vself.mtdfiltropesquisa();
              this.pagina_atual   = 1;
              let parametros      = [
                  {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                  {parametro: 'op',           valor  : 'qtdregistros'},
                  {parametro: 'filtro',       valor  : filtro}
              ];
              let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadplanospagamento.php');
              retorno.then(function (response) {
                  vself.pqtd_total_registros = parseInt(response.data.qtdregistros);
                  let qtdpg                  = Math.ceil(vself.pqtd_total_registros / vself.pqtdregistros);
                  vself.pqtd_paginas         = qtdpg > 0 ? qtdpg : 1;
                  vself.mtdcarregaplanospagamento(1);
              }).catch(function (response) {
                  alert('Erro ao consultar registros');
              });
          },
          mtdcarregaplanospagamento(ipagina){
                var vself       = this;
                let loader      = this.$loading.show();
                let filtro      = vself.mtdfiltropesquisa();
                let parametros  = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'listagem'},
                    {parametro: 'filtro',       valor : filtro},
                    {parametro: 'limit',        valor : vself.pqtdregistros},
                    {parametro: 'offset',       valor : (parseInt(ipagina) -1) * parseInt(vself.pqtdregistros)}
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadplanospagamento.php');
                retorno.then(function (response) {
                    vself.lstplanospagamento = response.data;
                    loader.hide();
                }).catch(function (response) {
                    vself.lstplanospagamento = [];
                    loader.hide();
                });
          },
          resetarDados() {
              util.toTop();

              this.vid                = '';
              this.vdescricao         = '';
              this.vidtabela          = null;
              this.vidforma           = null;
              this.vtipo              =  0;
              this.vpermitedesconto   = 1;
              this.vpercentrada       = 0;

              this.wt_tipoPlano       =  0;
              this.vidtipocob         = null;
              this.lstprazosplanos    = [];                
              this.vqtdparc           =  1;
              this.vprazos            = 30;

              this.planoPrazo         = true;
              this.planoPrazoLista    = false;

              $("#cbidforma").val('').trigger('change');
              $("#cbidtabela").val('').trigger('change');
              $("#cbidtipocobranca").val('').trigger('change');                
          },
          mtddefault(){
              $('#pnlista').hide();
              this.resetarDados();
              $('#pncadastro').fadeIn(700);
              this.$nextTick(function () {
                  if (parseInt(this.opcrud) < 3) {
                      $('#eddescricao').focus();
                  } else {
                      $('#btgravar').focus();
                  }
              });
          },
          mtdpreparacrud(op) {
              let vself    = this;
              vself.opcrud = op;
              vself.mtddefault();
          },
          mtdnovo(){
			if (!util.opcaousuario('001Z.016Z.001Z', this.$store.state.perfilusuario)){
				this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
			}else {
				this.itensbc.item2.titulo = 'INCLUSÃO DE PLANO DE PAGAMENTO';
				this.itensbc.item1.ativo  = true;
				this.itensbc.item2.ativo  = true;
				this.ativadesativa        = false;
				this.mtdpreparacrud(1);
			}
          },
          mtdcancelaredicao(){
              this.itensbc.item1.ativo = false;
              this.itensbc.item2.ativo = false;
              $('#pncadastro').hide();
              $('#pnlista').fadeIn(700);
              $('#edconteudopesq').focus();
              setTimeout(function(){
                  util.toTop();
              }, 200);
          },
          mtdlimpar_listagem() {
              this.lstplanospagamento   = [];
              this.pagina_atual         = 1;
              this.filtro               = '';
              this.pqtd_total_registros = 0;
              this.pqtd_paginas         = 0;
          },
          mtdgravar(){
              let vself = this;
				if (parseInt(vself.opcrud) < 3) {
					if (parseInt(vself.vtodasfiliais) === 0) {
					}
				}
				$.confirm({
					title: 'Confirmação!',
					content: 'Confirma ' + vself.itensbc.item2.titulo + '?',
					icon: 'fa fa-question-circle',
					escapeKey: true,
					backgroundDismiss: false,
					escapeKey: 'nao',
					type: 'dark',
					typeAnimated: true,
					buttons: {
						sim: {
							text: '<u>S</u>im',
							keys: ['s', 'S'],
							btnClass: 'btn-blue',
							action: function () {
								$('.btn-blue').prop('disabled', true);
								vself.mtdregistro();
							},
						},
						nao: {
							text: '<u>N</u>ão',
							keys: ['n', 'N'],
							action: function () {
								$('#btgravar').focus();
							}
						}
					}
				});
          },
          mtdlocalizaregistro(id){
              var vself       = this;
              let loader      = vself.$loading.show();
              let filtro      = ' and p.id='+id;
              let parametros  = [
                  {parametro: 'op',           valor : 'listagem'},
                  {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                  {parametro: 'filtro',       valor : filtro},
                  {parametro: 'limit',        valor : 1},
                  {parametro: 'offset',       valor : 0},
              ];
              let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadplanospagamento.php');
              retorno.then(function (response) {
                  loader.hide();
                  vself.mtdigualarcampos(response.data[0]);
                  if (parseInt(vself.opcrud) < 3){
                      $('#eddescricao').focus();
                  }else{
                      $('#btgravar').focus();
                  }
              }).catch(function (response) {
                  loader.hide();
              });
          },
          mtdalterar(item){
			if (!util.opcaousuario('001Z.016Z.002Z', this.$store.state.perfilusuario)){
				this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
			}else {
				this.itensbc.item2.titulo = 'ALTERAÇÃO DE PLANO DE PAGAMENTO';
				this.itensbc.item1.ativo  = true;
				this.itensbc.item2.ativo  = true;
				this.ativadesativa        = false;
				this.mtdpreparacrud(2);
				this.mtdlocalizaregistro(item.id);
			}
          },
          mtdexcluir(item){
			if (!util.opcaousuario('001Z.016Z.003Z', this.$store.state.perfilusuario)){
				this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
			}else {
				this.itensbc.item2.titulo = 'EXCLUSÃO DE PLANO DE PAGAMENTO';
				this.itensbc.item1.ativo  = true;
				this.itensbc.item2.ativo  = true;
				this.ativadesativa        = true;
				this.mtdpreparacrud(3);
				this.mtdlocalizaregistro(item.id);
			}
          },
          mtdigualarcampos(registro){
              this.vid                 = registro.id;
              this.vdescricao          = registro.descricao;
              this.vidtabela           = registro.idtabela;
              this.vidforma            = registro.idforma;
              this.wt_tipoPlano        = registro.tipo;              
              this.vtipo               = registro.tipo;
              this.vpermitedesconto    = registro.permitedesconto;            

              var defforma             = new Option(registro.descforma, registro.idforma, true, true);
              $('#cbidforma').append(defforma).trigger('change');

              var deftab               = new Option(registro.desctabela, registro.idtabela, true, true);
              $('#cbidtabela').append(deftab).trigger('change');

              this.lstprazosplanos     = registro.prazosplanos;
              setTimeout(() => {
                  this.vpercentrada        = parseFloat(registro.percentrada); 
              }, 300);
          },
          mtdregistro(){
              let vself  = this;
              let loader = vself.$loading.show();
              let registrocrud = {
                  'id'                : this.vid,
                  'descricao'         : this.vdescricao,
                  'idforma'           : this.vidforma,
                  'idtabela'          : this.vidtabela,
                  'tipo'              : this.vtipo,
                  'permitedesconto'   : this.vpermitedesconto,
                  'percentrada'       : this.vpercentrada,  
                  'prazosplanos'      : this.lstprazosplanos    
              };
              let parametros      = [
                  {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                  {parametro: 'op',           valor : 'rotinacrud'},
                  {parametro: 'opcrud',       valor : vself.opcrud},
                  {parametro: 'registro',     valor : JSON.stringify(registrocrud)},
                  {parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
                  {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                  {parametro: 'codop',        valor : parseInt(this.opcrud) === 1 ? '001Z.016Z.001Z' : parseInt(this.opcrud) === 2 ? '001Z.016Z.002Z' : '001Z.016Z.003Z'},
              ];
              let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadplanospagamento.php');
              retorno.then(function (response) {
                  loader.hide();
                  if ($.isNumeric(response.data)){
                      vself.$toastr.s('Registro processado com sucesso!', 'Informação!');
                      vself.pfiltro       = 0;
                      vself.pconteudo     = parseInt(vself.opcrud) === 1 ? response.data : vself.vid;
                      vself.pqtd_paginas  = 1;
                      vself.mtdcancelaredicao();
                      vself.mtdcarregaplanospagamento(1);
                  }else{
                      let tpret = response.data.substring(0,1);
                      switch (tpret) {
                          case 'I':
                              vself.$toastr.w(response.data.substring(4), 'Atenção!');
                              break;
                          case 'E': default:
                              vself.$toastr.e(response.data.substring(4), 'Erro!');
                              break;
                      }
                  }
              }).catch(function (response) {
                  loader.hide();
                  vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
              });
          },
          mtdselect2_def(){
              let vself  = this;               

              $("#cbidforma").select2({
                  id: function (e) {return e.id},
                  ajax: {
                      url: vself.$store.state.configpaths.pathselect2,
                      dataType: 'json',
                      delay: 250,
                      data: function (params) {
                          return {
                              q: params.term,
                              idclientesac : vself.$store.state.filialpadrao.idcliente,
                              tb: 'tbformaspagamento',
                              c1: 'id',
                              c2: 'descricao'
                          };
                      },
                      processResults: function (data) {
                          return {
                              results: data
                          };
                      },
                      cache: true
                  },
                  minimumInputLength: 0,
                  theme: 'bootstrap',
                  language: "pt-BR",
                  templateResult: util.formatResult,
                  templateSelection: util.formatSelection
              }).change(function () {
                  vself.vidforma = $("#cbidforma").val();
              });                

              $("#cbidtabela").select2({
                  id: function (e) {return e.id},
                  ajax: {
                      url: vself.$store.state.configpaths.pathselect2,
                      dataType: 'json',
                      delay: 250,
                      data: function (params) {
                          return {
                              q: params.term,
                              idclientesac : vself.$store.state.filialpadrao.idcliente,
                              tb: 'tbtabelasprecos',
                              c1: 'id',
                              c2: 'descricao'
                          };
                      },
                      processResults: function (data) {
                          return {
                              results: data
                          };
                      },
                      cache: true
                  },
                  minimumInputLength: 0,
                  theme: 'bootstrap',
                  language: "pt-BR",
                  templateResult: util.formatResult,
                  templateSelection: util.formatSelection
              }).change(function () {
                  vself.vidtabela = $("#cbidtabela").val();
              });
              
              $("#cbidtipocobranca").select2({
                  id: function (e) {return e.id},
                  ajax: {
                      url: vself.$store.state.configpaths.pathselect2,
                      dataType: 'json',
                      delay: 250,
                      data: function (params) {
                          return {
                              q: params.term,
                              idclientesac : vself.$store.state.filialpadrao.idcliente,
                              tb: 'tbtiposcobranca',
                              c1: 'id',
                              c2: 'descricao'
                          };
                      },
                      processResults: function (data) {
                          return {
                              results: data
                          };
                      },
                      cache: true
                  },
                  minimumInputLength: 0,
                  theme: 'bootstrap',
                  language: "pt-BR",
                  templateResult: util.formatResult,
                  templateSelection: util.formatSelection
              }).change(function () {
                  vself.vidtipocob = $("#cbidtipocobranca").val();
              }); 
              
            $('#mdprazos').on('shown.bs.modal', function() {
                $(this).find('[autofocus]').focus();
            });              
          },
          mtdlancarPrazos() {
              if (this.vidtipocob === null || this.vidtipocob === undefined || this.vidtipocob === '') {
                this.$toastr.w('Informe um tipo de cobrança!', 'Informação!');
                $("#cbidtipocobranca").focus();
                return;
              }

              this.lstprazosplanos = [];

              if(this.vqtdparc > 0){
                  let i = 0;
                  let len = this.vqtdparc;
                  for (; i < len; ) {
                      i++;
                      let newPrazos = {
                          'idparcela'           : i,
                          'prazo'               : this.vprazos * i,
                          'idtipocob'           : $('#cbidtipocobranca').val(),
                          'descricaocob'        : $('#cbidtipocobranca').select2('data')[0]['text']
                      };

                      this.lstprazosplanos.push(newPrazos);
                  }
              }

              this.vqtdparc    = 1;
              this.vprazos     = 30;
              this.$nextTick(function () {
                  $("#cbidtipocobranca").focus();
              });
          },
          mtdexcluirprazo(prazo) {
            this.lstprazosplanos.splice(util.getArrayIndexForKey(this.lstprazosplanos, 'idparcela', prazo.idparcela), 1);
          },
          mtdalterarprazos(listaPrazosAlt){
            //iguala os dados da pparcela para poder fazer a alteração
            this.vidparcelaalt     = listaPrazosAlt.idparcela;
            this.vprazoalt         = listaPrazosAlt.prazo;
                        
            $('#mdprazos').modal('show');  //edvprazoalt
          },
          checkKeyUpParcela: function (event) {
            if (event.key === 'Enter') {
              let indxParcelaAlt = util.getArrayIndexForKey(this.lstprazosplanos, 'idparcela', this.vidparcelaalt);
              this.lstprazosplanos[indxParcelaAlt].prazo      = this.vprazoalt;

              $('#mdprazos').modal('hide');
              this.$toastr.s('Intervalo alterado com sucesso!', 'Informação!');
            }
          },                                                       
        },
        mounted: function () {
          if (util.verificasessao(this)) {
            let vself = this;
            let loader = vself.$loading.show();
            let parametros = [
                {parametro: 'op', valor: 'dadosusuario'},
                {parametro: 'idclientesac', valor  : vself.$store.state.usuario.idclientesac},
                {parametro: 'idusuario', valor: vself.$store.state.usuario.id}
            ];
            let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rotinasusuario.php');
            retorno.then(function (response) {
                loader.hide();
                vself.$store.commit('MUDAR_PERFIL_USUARIO', response.data.perfilusu);
                if (util.opcaousuario('001Z.016Z', vself.$store.state.perfilusuario)) {
                    $('#pnlista').fadeIn(700);
                    vself.mtdexecutapesquisa();
                    vself.mtdselect2_def();

                    $(document).keydown(function (e) {
                        if(e.which === 27) {
                          $('#mdprazos').modal('hide');
                        }
                    });                    
                } else {
                    vself.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                    setTimeout(function(){
                        util.gotoprincipal();
                    },1000);
                }
            }).catch(function (response) {
                loader.hide();
                console.log(response.message);
            });
          }
        },
        computed:{
            validou() {
                return this.vdescricao === '' || this.vidforma === null || this.vidtabela === null;
            }
        },
        watch:{
          pagina_atual(val){
              this.mtdcarregaplanospagamento(val);
          },
          wt_tipoPlano: function (val) {
              this.vtipo                 = parseInt(val);
              this.vpercentrada          = 0;  
              if(this.vtipo === 0){
                  this.planoPrazo        = true;
                  this.planoPrazoLista   = false;
              }else{
                  this.planoPrazo        = false;
                  this.planoPrazoLista   = true;

                  if(this.ativadesativa){
                    this.planoPrazo      = true;
                  }
              }
          }                     
        }
    }
</script>
<style>
    .def-col-cod{
        width: 80px !important;
    }
    .def-col-tipo{
        width: 80px !important;
    }     
    #btclonarperfilusuario{
        cursor: pointer;
        font-weight: bold;
        font-size: 18px;
        position: relative;
        float: right;
        top: 5px;
        transition: .35s;
    }
    #btmarcartodosopusuario{
        font-weight: bold;
        font-size: 18px;
        padding-right: 10px;
        cursor: pointer;
        position: relative;
        float: right;
        top: 5px;
        transition: .35s;
    }
    #btmarcartodosopusuario:hover{
        color: #666666;
        transition: .35s;
    }

    #btmarcartodfiliais{
        font-weight: bold;
        font-size: 18px;
        padding-right: 10px;
        cursor: pointer;
        position: relative;
        float: right;
        top: 5px;
        transition: .35s;
    }
    #btmarcartodfiliais:hover{
        color: #666666;
        transition: .35s;
    }
    #btclonarperfilusuario:hover{
        color: #666666;
        transition: .35s;
    }
    .excplanos{
        color: #8c8b8b;
        font-size: 22px;
        margin-right: 5px;
        margin-left: 5px;
    }
    .titplanos{
        font-size: 14px;
    }    
</style>